import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { constants } from '@constants/constants';
import { SettingsService } from '@webapi/services/settings.service';
import { EMPTY, from, interval } from 'rxjs';
import { catchError, exhaustMap, filter, take } from 'rxjs/operators';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  private static readonly statusCheckIntervalMs = 10000;

  constructor(
    private settingsService: SettingsService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    const returnUrlKey = constants.localStorageKeys.maintenanceReturnUrl;
    const returnUrl = localStorage.getItem(returnUrlKey);
    const retryUrl = returnUrl?.startsWith('/') && !returnUrl.startsWith('/maintenance') ? returnUrl : '/';

    interval(MaintenanceComponent.statusCheckIntervalMs)
      .pipe(
        exhaustMap(() =>
          from(this.settingsService.getMaintenanceConfiguration(true)).pipe(catchError(() => EMPTY))
        ),
        filter(maintenance => maintenance?.isActive === false),
        take(1),
        untilDestroyed(this)
      )
      .subscribe(() => this.document.location.replace(`${this.document.location.origin}${retryUrl}`));
  }
}
